/* template */
<template><mpx-view :class="([activeClass,className,externClass])" :style="[(borderStyle)] | transRpxStyle" @tap="handleClick" @tap.stop="handleCatchClick" class="ts-button"><slot></slot></mpx-view></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m9b0ba146"}'>
  .ts-button
    position relative
    box-sizing border-box
    font-size 16px
    text-align center
    background-color #fff
    cursor pointer
    transition opacity 0.2s
    -webkit-tap-highlight-color transparent
    -moz-tap-highlight-color transparent
    &::after
      position absolute
      content ''
      width 200%
      height 200%
      box-sizing border-box
      border var(--borderlg) solid var(--bordercl)
      transform-origin 0 0
      transform scale(0.5)
      border-radius var(--borderrd)
      top 0
      left 0
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m9b0ba146"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex9b0ba146%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex9b0ba146%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m9b0ba146"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index9b0ba146/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
